import PropTypes from 'prop-types';
import React from 'react';
import TagManager from 'react-gtm-module';
import _ from 'lodash';

import { generateKey } from '@/utils';
import {
  Wrapper,
  Salon,
  Title,
  Number,
  Name,
  Detail,
  Label,
  Link,
  Bottom,
  View,
  Distance,
  distance,
  LineImages,
  LineImage,
  LineImageTooltip,
} from './List.style';

const getProducts = products =>
  products.reduce((acc, child) => {
    if (typeof child.children === 'undefined') {
      return [...acc, child];
    } else if (child.children && child.children.length > 0) {
      const hairCareSeries = _.find(child.children, { key: 'THE HAIR CARE' });
      if (hairCareSeries) {
        return [...acc, ...hairCareSeries.children];
      }
      return [...acc, ...child.children];
    }
    return acc;
  }, []);

// 「SUBLIMIC」の label は母国語に設定される可能性があるため、key を参照する。
// 「SUBLIMIC > SPA EXPERT」を追加
const getSublimicProduct = products => {
  const result = [];
  products.some(item => {
    const linesIndex = item.children.findIndex(line => line.key === 'SUBLIMIC');
    if (linesIndex > -1) {
      result.push({
        contentType: item.children[linesIndex].contentType,
        entryId: item.children[linesIndex].entryId,
        key: item.children[linesIndex].key,
        label: item.children[linesIndex].label,
        productImage: item.children[linesIndex].productImage,
        shortDescription: item.children[linesIndex].ShortDescription,
        url: item.children[linesIndex].url,
      });
      result.push({
        key: item.children[linesIndex].key2,
        label: item.children[linesIndex].key2Label,
        productImage: item.children[linesIndex].key2ProductImage,
        shortDescription: item.children[linesIndex].key2ShortDescription,
      });
      return true;
    }
  });
  return result;
};

const getLines = (products, salon) => {
  const categories = ['lines_HairCare', 'lines_HairColor', 'lines_Styling', 'lines_Perm', 'lines_Mens'];
  let targetProduct = getProducts(products);
  targetProduct = targetProduct.concat(getSublimicProduct(products));
  const returnLines = [];
  categories.map(category => {
    const lines = salon[category];
    if (lines !== undefined) {
      // TODO: item.key があるものとないものがあるので、要確認。
      lines.map(line =>
        returnLines.push(
          targetProduct.find(item => item && Object.hasOwnProperty.call(item, 'key') && item.key === line)
        )
      );
    }
    return true;
  });
  return returnLines;
};

const List = ({ coords, copy, show, salons, setFocus, products }) => (
  <Wrapper show={show}>
    {salons.map((salon, i) => (
      <Salon key={generateKey('salon', i)}>
        <Title>
          <Number>{`${i + 1}.`}</Number>
          <Name>{salon.name}</Name>
        </Title>
        {(salon.address1 || salon.address2) && (
          <Detail>
            <Link
              href={
                salon.country === '日本'
                  ? `https://maps.google.co.jp/maps?q=${encodeURIComponent(salon.address2)} ${encodeURIComponent(
                      salon.address1
                    )} ${encodeURIComponent(salon.name)}`
                  : `https://maps.google.co.jp/maps?q=${encodeURIComponent(salon.address1)} ${encodeURIComponent(
                      salon.address2
                    )} ${encodeURIComponent(salon.name)}`
              }
              target="_blank"
              onClick={() => {
                TagManager.dataLayer({
                  dataLayer: {
                    event: 'salonlocator',
                    sl_item: salon.name,
                  },
                });
              }}
            >
              {salon.country === '日本'
                ? [`〒${salon.zipCode}`, salon.address2, salon.address1].filter(field => !!field).join(' ')
                : [salon.address1, salon.address2, salon.zipCode].filter(field => !!field).join(' ')}
            </Link>
          </Detail>
        )}
        {salon.nearbyStations && (
          <Detail>
            <Label>{copy.nearby_stations}:</Label>
            {salon.nearbyStations.join(', ')}
          </Detail>
        )}
        {salon.phoneNumber && (
          <Detail>
            <Label>{copy.phone_number}:</Label>
            <Link href={`tel:${salon.phoneNumber}`}>{salon.phoneNumber}</Link>
          </Detail>
        )}
        <LineImages className="line-images">
          {getLines(products, salon).map(line => {
            const element = !!line && (
              <LineImage key={`${line.name}${line.entryId}`} className="line-image">
                <LineImageTooltip className="tooltip">
                  <img src={line.productImage.file.url} alt={line.name} />
                  <div className="content">
                    <div className="name">{line.name || line.label}</div>
                    <div className="description">{line.shortDescription}</div>
                  </div>
                </LineImageTooltip>
                <div className="image">
                  <img src={line.productImage.file.url} alt={line.name} />
                </div>
              </LineImage>
            );
            return element;
          })}
        </LineImages>
        {salon.website && (
          <Detail>
            <Label>{`${copy.website}: `}</Label>
            <Link href={salon.website} target="_blank">
              {salon.website}
            </Link>
          </Detail>
        )}
        {'parking' in salon && (
          <Detail>
            <Label>{copy.has_parking}:</Label>
            {salon.parking ? copy.yes : copy.no}
          </Detail>
        )}
        <Bottom>
          <View
            onClick={() => {
              setFocus(i);
              TagManager.dataLayer({
                dataLayer: {
                  event: 'salonlocator',
                  sl_item: `View On Map_${salon.name}`,
                },
              });
            }}
          >
            View On Map
          </View>
          <Distance>{distance(salon.location, coords)}</Distance>
        </Bottom>
      </Salon>
    ))}
  </Wrapper>
);

List.propTypes = {
  coords: PropTypes.shape().isRequired,
  copy: PropTypes.shape().isRequired,
  salons: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  setFocus: PropTypes.func.isRequired,
  show: PropTypes.bool.isRequired,
  products: PropTypes.arrayOf(PropTypes.shape()).isRequired,
};

export default List;



// WEBPACK FOOTER //
// ./src/pages/SalonLocator/ResultSection/List.js